module.exports = __webpack_public_path__ + "static/img/98.9735dc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/98.png
// module id = uzG3
// module chunks = 0